// extracted by mini-css-extract-plugin
export default {"avatar":"RqPp5et","clickable":"dvybPKy"};